export enum NftActivities {
  MINT = "mint",
  BURN = "burn",
  TRANSFER = "transfer",
  AUCTION_CREATE = "auctionCreate",
  AUCTION_DUTCH_CREATE = "auctionDutchCreate",
  AUCTION_SUCCESS = "auctionSuccess",
  AUCTION_CANCEL = "auctionCancel",
  AUCTION_RESERVE = "auctionReserve",
  OFFER_CREATE = "offerCreate",
  OFFER_ACCEPT = "offerAccept",
  OFFER_CANCEL = "offerCancel",
  COLLECTION_OFFER_CREATE = "collectionOfferCreate",
  COLLECTION_OFFER_CANCEL = "collectionOfferCancel",
  PRIVATE_AUCTION_SUCCESS = "privateAuctionSuccess",
}

export type ArgKeys =
  | "initiator"
  | "from"
  | "to"
  | "price"
  | "totalPrice"
  | "paymentLabel";

type ActivityConfigItem = {
  text: string;
  args?: ArgKeys[];
};

export type ActivityConfigType = Partial<
  Record<NftActivities, ActivityConfigItem>
>;
